<template>
  <div class="notice-detail">
    <div v-loading="tipLoading">
      <div class="wrapper">
        <div style="margin-top:15px" class="ccui-clearfix wrapper">
          <div class="title fl">
            {{ $t("page.content.procurementAnnouncement") }}
          </div>
          <div class="title fl old-version" @click="oldLink">
            {{ $t("page.content.laowucaiLink") }}<i class="el-icon-link"></i>
            <span
              class="old-note"
              style="color:red;font-size:13px;"
              :title="languagezh_cn ? '' : $t('page.content.laowucaiLinkMsg')"
              >{{ $t("page.content.laowucaiLinkMsg") }}</span
            >
          </div>
          <el-link
            :underline="false"
            type="info"
            class="fr view-all"
            @click="handleViewAll(tabName)"
            style="transform: translateY(20px);"
            >{{ $t("page.content.MoreAndMore") }} ></el-link
          >
        </div>
        <div class="notice-list mt20 mb20" style="height:49px">
          <el-tabs
            class="notice-list-tabs"
            v-model="tabName"
            @tab-click="handleClick"
          >
            <!--采购公告-->
            <el-tab-pane
              :label="$t('page.content.procurementAnnouncement')"
              name="98"
              class="notice-list-group clearfix"
            >
            </el-tab-pane>
            <!--邀请公告-->
            <el-tab-pane
              v-if="isShowInvi"
              :label="$t('page.content.inviteNotice')"
              name="99"
              class="notice-list-group clearfix"
            >
            </el-tab-pane>
            <!--补遗公告-->
            <el-tab-pane
              :label="$t('page.content.labelMenu3')"
              name="7"
              class="notice-list-group clearfix"
            >
            </el-tab-pane>
            <!--流标公告-->
            <el-tab-pane
              :label="$t('page.content.labelMenu2')"
              name="8"
              class="notice-list-group clearfix"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
        <!--采购公告、邀请公告-->
        <div v-if="tabName == 98 || tabName == 99">
          <el-table
            :data="noticeData"
            header-cell-class-name="table_header"
            :border="false"
            :row-style="{ height: 0 }"
            style="width: 100%; margin-top: 20px"
            :empty-text="$t('page.content.noData')"
          >
            <el-table-column
              prop="noticeTitle"
              :label="$t('page.content.noticeName')"
              width="380"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }">
                <a @click="handleView(row)" class="a-line">{{
                  row.noticeTitle
                }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="bigClassName"
              :label="$t('page.content.category')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }"
                ><span>{{ row.bigClassName.join(",") }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="purchaseTypeName"
              :label="$t('page.content.purchaseType')"
            >
              <template slot-scope="{ row }"
                ><span :title="row.purchaseName">{{
                  row.purchaseType == "2"
                    ? row.purchaseClassName
                      ? row.purchaseClassName
                      : row.purchaseType == "1"
                      ? $t("page.content.inquiry")
                      : row.purchaseType == "2"
                      ? $t("page.content.otherProcurement")
                      : row.purchaseType == "5"
                      ? $t("page.content.inviteBidd")
                      : row.purchaseType == "7"
                      ? $t("page.content.labelMenu10")
                      : row.purchaseType == "8"
                      ? $t("page.content.labelMenu11")
                      : row.purchaseType == "24"
                      ? $t("page.content.openCompetitiveNegotiation")
                      : row.purchaseType == "4"
                      ? $t("page.content.competitiveNegotiation")
                      : row.purchaseType == "50"
                      ? $t("page.content.agreementType")
                      : row.purchaseType == "53"
                      ? $t("page.content.invitationType")
                      : row.purchaseType == "0"
                      ? $t("page.content.publicBidding")
                      : row.purchaseType == "3"
                      ? $t("page.content.invitationTender")
                      : ""
                    : row.purchaseType == "1"
                    ? $t("page.content.inquiry")
                    : row.purchaseType == "2"
                    ? $t("page.content.otherProcurement")
                    : row.purchaseType == "5"
                    ? $t("page.content.inviteBidd")
                    : row.purchaseType == "7"
                    ? $t("page.content.labelMenu10")
                    : row.purchaseType == "8"
                    ? $t("page.content.labelMenu11")
                    : row.purchaseType == "24"
                    ? $t("page.content.openCompetitiveNegotiation")
                    : row.purchaseType == "4"
                    ? $t("page.content.competitiveNegotiation")
                    : row.purchaseType == "50"
                    ? $t("page.content.agreementType")
                    : row.purchaseType == "53"
                    ? $t("page.content.invitationType")
                    : row.purchaseType == "0"
                    ? $t("page.content.publicBidding")
                    : row.purchaseType == "3"
                    ? $t("page.content.invitationTender")
                    : ""
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.publishTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.noticeStartTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="moneytypeStr"
              :label="$t('page.content.ApplicationTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  row.purchaseType == "2"
                    ? row.noticeEndTime
                    : row.firstRoundEndTime
                    ? moment(row.firstRoundEndTime).format("YYYY-MM-DD HH:mm")
                    : row.firstRoundEndTime
                }}</span></template
              >
            </el-table-column>
          </el-table>
          <!--分页Begin-->
          <!--<div class="ccui-table-footer" v-show="noticeData.length > 0">-->
          <!--<div class="ccui-operation">-->
          <!--<slot name="batchOp"></slot>-->
          <!--</div>-->

          <!--<div id="ccui-paging">-->
          <!--<el-pagination-->
          <!--:total="pageTotal"-->
          <!--:page-size="pageSize"-->
          <!--:current-page="pageNo"-->
          <!--:page-sizes="[10, 20, 50, 100, 200, 500]"-->
          <!--background-->
          <!--layout="total, sizes, prev, pager, next, jumper"-->
          <!--popper-class="ccui-paging-page-size-popper"-->
          <!--@prev-click="handlePrev"-->
          <!--@next-click="handleNext"-->
          <!--@size-change="handleSizeChange"-->
          <!--@current-change="handleCurrentChange"-->
          <!--/>-->
          <!--<el-button-->
          <!--class="ccui-pagination-btn"-->
          <!--size="mini"-->
          <!--type="default"-->
          <!--@click="handleSizeChange('none')"-->
          <!--&gt;确定</el-button-->
          <!--&gt;-->
          <!--</div>-->
          <!--</div>-->
          <!--分页End-->
        </div>
        <!--补遗公告-->
        <div v-if="tabName == 7">
          <!-- <template v-for="(item, index) in nodeList7">
            <a @click="handleViewDetail(item)" :key="index">
              <span class="ellipsis" :title="showNoticeTitle(item)">{{
                showNoticeTitle(item)
              }}</span>
              <span>{{
                item.noticeStartTime
                  ? moment(item.noticeStartTime).format("YYYY-MM-DD")
                  : ""
              }}</span>
            </a>
          </template> -->
          <el-table
            :data="noticeData"
            header-cell-class-name="table_header"
            :border="false"
            :row-style="{ height: 0 }"
            style="width: 100%; margin-top: 20px"
            :empty-text="$t('page.content.noData')"
          >
            <el-table-column
              prop="noticeTitle"
              :label="$t('page.content.noticeName')"
              width="380"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }">
                <a @click="handleView(row, tabName)" class="a-line">{{
                  row.noticeTitle
                }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="bigClassName"
              :label="$t('page.content.category')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }"
                ><span>{{ row.bigClassName.join(",") }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="purchaseTypeName"
              :label="$t('page.content.purchaseType')"
            >
              <template slot-scope="{ row }"
                ><span :title="row.purchaseName">{{
                  row.purchaseType == "2"
                    ? row.purchaseClassName
                      ? row.purchaseClassName
                      : row.purchaseType == "1"
                      ? $t("page.content.inquiry")
                      : row.purchaseType == "2"
                      ? $t("page.content.otherProcurement")
                      : row.purchaseType == "5"
                      ? $t("page.content.inviteBidd")
                      : row.purchaseType == "7"
                      ? $t("page.content.labelMenu10")
                      : row.purchaseType == "8"
                      ? $t("page.content.labelMenu11")
                      : row.purchaseType == "24"
                      ? $t("page.content.openCompetitiveNegotiation")
                      : row.purchaseType == "4"
                      ? $t("page.content.competitiveNegotiation")
                      : row.purchaseType == "50"
                      ? $t("page.content.agreementType")
                      : row.purchaseType == "53"
                      ? $t("page.content.invitationType")
                      : row.purchaseType == "0"
                      ? $t("page.content.publicBidding")
                      : row.purchaseType == "3"
                      ? $t("page.content.invitationTender")
                      : ""
                    : row.purchaseType == "1"
                    ? $t("page.content.inquiry")
                    : row.purchaseType == "2"
                    ? $t("page.content.otherProcurement")
                    : row.purchaseType == "5"
                    ? $t("page.content.inviteBidd")
                    : row.purchaseType == "7"
                    ? $t("page.content.labelMenu10")
                    : row.purchaseType == "8"
                    ? $t("page.content.labelMenu11")
                    : row.purchaseType == "24"
                    ? $t("page.content.openCompetitiveNegotiation")
                    : row.purchaseType == "4"
                    ? $t("page.content.competitiveNegotiation")
                    : row.purchaseType == "50"
                    ? $t("page.content.agreementType")
                    : row.purchaseType == "53"
                    ? $t("page.content.invitationType")
                    : row.purchaseType == "0"
                    ? $t("page.content.publicBidding")
                    : row.purchaseType == "3"
                    ? $t("page.content.invitationTender")
                    : ""
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.publishTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.noticeStartTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
          </el-table>
        </div>
        <!--流标公告-->
        <div v-if="tabName == 8">
          <!-- <template v-for="(item, index) in nodeList8">
            <a @click="handleViewDetail(item)" :key="index">
              <span class="ellipsis" :title="showNoticeTitle(item)">{{
                showNoticeTitle(item)
              }}</span>
              <span>{{
                item.noticeStartTime
                  ? moment(item.noticeStartTime).format("YYYY-MM-DD")
                  : ""
              }}</span>
            </a>
          </template> -->
          <el-table
            :data="noticeData"
            header-cell-class-name="table_header"
            :border="false"
            :row-style="{ height: 0 }"
            style="width: 100%; margin-top: 20px"
            :empty-text="$t('page.content.noData')"
          >
            <el-table-column
              prop="noticeTitle"
              :label="$t('page.content.noticeName')"
              width="380"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }">
                <a @click="handleView(row, tabName)" class="a-line">{{
                  row.noticeTitle
                }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="bigClassName"
              :label="$t('page.content.category')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }"
                ><span>{{ row.bigClassName.join(",") }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="purchaseTypeName"
              :label="$t('page.content.purchaseType')"
            >
              <template slot-scope="{ row }"
                ><span :title="row.purchaseName">{{
                  row.purchaseType == "2"
                    ? row.purchaseClassName
                      ? row.purchaseClassName
                      : row.purchaseType == "1"
                      ? $t("page.content.inquiry")
                      : row.purchaseType == "2"
                      ? $t("page.content.otherProcurement")
                      : row.purchaseType == "5"
                      ? $t("page.content.inviteBidd")
                      : row.purchaseType == "7"
                      ? $t("page.content.labelMenu10")
                      : row.purchaseType == "8"
                      ? $t("page.content.labelMenu11")
                      : row.purchaseType == "24"
                      ? $t("page.content.openCompetitiveNegotiation")
                      : row.purchaseType == "4"
                      ? $t("page.content.competitiveNegotiation")
                      : row.purchaseType == "50"
                      ? $t("page.content.agreementType")
                      : row.purchaseType == "53"
                      ? $t("page.content.invitationType")
                      : row.purchaseType == "0"
                      ? $t("page.content.publicBidding")
                      : row.purchaseType == "3"
                      ? $t("page.content.invitationTender")
                      : ""
                    : row.purchaseType == "1"
                    ? $t("page.content.inquiry")
                    : row.purchaseType == "2"
                    ? $t("page.content.otherProcurement")
                    : row.purchaseType == "5"
                    ? $t("page.content.inviteBidd")
                    : row.purchaseType == "7"
                    ? $t("page.content.labelMenu10")
                    : row.purchaseType == "8"
                    ? $t("page.content.labelMenu11")
                    : row.purchaseType == "24"
                    ? $t("page.content.openCompetitiveNegotiation")
                    : row.purchaseType == "4"
                    ? $t("page.content.competitiveNegotiation")
                    : row.purchaseType == "50"
                    ? $t("page.content.agreementType")
                    : row.purchaseType == "53"
                    ? $t("page.content.invitationType")
                    : row.purchaseType == "0"
                    ? $t("page.content.publicBidding")
                    : row.purchaseType == "3"
                    ? $t("page.content.invitationTender")
                    : ""
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.publishTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.noticeStartTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="wrapper">
        <div class="ccui-clearfix wrapper">
          <div class="title fl">{{ $t("page.content.wasteNotice") }}</div>
          <el-link
            :underline="false"
            type="info"
            class="fr view-all"
            style="transform: translateY(20px);"
            @click="handleViewAll('12')"
            >{{ $t("page.content.MoreAndMore") }} ></el-link
          >
        </div>
        <div class="pro-notice">
          <el-table
            :data="wasteData"
            header-cell-class-name="table_header"
            :border="false"
            :row-style="{ height: 0 }"
            style="width: 100%; margin-top: 20px"
            :empty-text="$t('page.content.noData')"
          >
            <el-table-column
              prop="noticeTitle"
              :label="$t('page.content.noticeName')"
              width="350"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }">
                <a @click="handleView(row)" class="a-line">{{
                  row.noticeTitle
                }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="bigClassName"
              :label="$t('page.content.category')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }"
                ><span>{{ row.bigClassName.join(",") }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="purchaseTypeName"
              :label="$t('page.content.purchaseType')"
            >
              <!-- // row.purchaseTypeName == `${$t("page.content.labelMenu11")}` -->
              <template slot-scope="{ row }"
                ><span :title="row.purchaseName">{{
                  row.purchaseTypeName == "公开竞价"
                    ? `${$t("page.content.labelMenu12")}`
                    : row.purchaseType == "1"
                    ? $t("page.content.inquiry")
                    : row.purchaseType == "2"
                    ? $t("page.content.otherProcurement")
                    : row.purchaseType == "5"
                    ? $t("page.content.inviteBidd")
                    : row.purchaseType == "7"
                    ? $t("page.content.labelMenu10")
                    : row.purchaseType == "8"
                    ? $t("page.content.labelMenu11")
                    : row.purchaseType == "24"
                    ? $t("page.content.openCompetitiveNegotiation")
                    : row.purchaseType == "4"
                    ? $t("page.content.competitiveNegotiation")
                    : row.purchaseType == "50"
                    ? $t("page.content.agreementType")
                    : row.purchaseType == "53"
                    ? $t("page.content.invitationType")
                    : row.purchaseType == "0"
                    ? $t("page.content.publicBidding")
                    : row.purchaseType == "3"
                    ? $t("page.content.invitationTender")
                    : ""
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.publishTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.noticeStartTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="moneytypeStr"
              :label="$t('page.content.ApplicationTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  row.firstRoundEndTime
                    ? moment(row.firstRoundEndTime).format("YYYY-MM-DD HH:mm")
                    : row.firstRoundEndTime
                }}</span></template
              >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!--联合采购专区-->
      <div class="wrapper">
        <div class="ccui-clearfix wrapper">
          <div class="title fl">{{ $t("page.content.lianhecaigou") }}</div>
          <el-link
            :underline="false"
            type="info"
            class="fr view-all"
            style="transform: translateY(20px);"
            @click="handleViewLianhe(1, 2)"
            >{{ $t("page.content.MoreAndMore") }} ></el-link
          >
        </div>
        <div class="pro-notice">
          <el-table
            :data="lianheData"
            header-cell-class-name="table_header"
            :border="false"
            :row-style="{ height: 0 }"
            style="width: 100%; margin-top: 20px"
            :empty-text="$t('page.content.noData')"
          >
            <el-table-column
              prop="noticeTitle"
              :label="$t('page.content.xunjiaName')"
              width="350"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }">
                <a @click="handleViewLianhe(row, 1)" class="a-line">{{
                  row.purchaseName
                }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="bigClassName"
              :label="$t('page.content.category')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }"
                ><span>{{ row.type }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="purchaseTypeName"
              :label="$t('page.content.xunjiaType')"
            >
              <!-- // row.purchaseTypeName == `${$t("page.content.labelMenu11")}` -->
              <template slot-scope="{ row }"
                ><span :title="row.purchaseName">{{
                  $t("page.content.labelMenu10")
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.publishTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.publishedTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.xunjiajiezhiTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.purchaseEndTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!--海外采购专区公告-->
      <div class="wrapper">
        <div class="ccui-clearfix wrapper">
          <div class="title fl">{{ $t("page.content.haiwaicaigou") }}</div>
          <el-link
            :underline="false"
            type="info"
            class="fr view-all"
            style="transform: translateY(20px);"
            @click="handleViewOverseas(1, 2)"
            >{{ $t("page.content.MoreAndMore") }} ></el-link
          >
        </div>
        <div class="pro-notice">
          <el-table
            :data="overseasData"
            header-cell-class-name="table_header"
            :border="false"
            :row-style="{ height: 0 }"
            style="width: 100%; margin-top: 20px"
            :empty-text="$t('page.content.noData')"
          >
            <el-table-column
              prop="noticeTitle"
              :label="$t('page.content.noticeName')"
              width="350"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }">
                <a @click="handleViewOverseas(row, 1)" class="a-line">{{
                  row.purchaseName
                }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="bigClassName"
              :label="$t('page.content.category')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }"
                ><span>{{ row.type }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="purchaseType"
              :label="$t('page.content.purchaseType')"
            >
              <!-- // row.purchaseTypeName == `${$t("page.content.labelMenu11")}` -->
              <template slot-scope="{ row }"
                ><span :title="row.purchaseType">{{
                  row.purchaseType
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.publishTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.publishedTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.deadlineEndTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.purchaseEndTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!--商城式订单采购公告-->
      <div class="wrapper" v-if="loginInfo.mobile">
        <div class="ccui-clearfix wrapper">
          <div class="title fl">
            {{ $t("page.content.mallPurchaseAnnouncement") }}
          </div>
          <el-link
            :underline="false"
            type="info"
            class="fr view-all"
            style="transform: translateY(20px);"
            @click="handleViewAll(9)"
            >{{ $t("page.content.MoreAndMore") }} ></el-link
          >
        </div>
        <div class="pro-notice">
          <el-table
            :data="mallPurchaseData"
            header-cell-class-name="table_header"
            :border="false"
            :row-style="{ height: 0 }"
            style="width: 100%; margin-top: 20px"
            :empty-text="$t('page.content.noData')"
          >
            <el-table-column
              prop="purchaseName"
              :label="$t('page.content.noticeName')"
              width="350"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }">
                <a @click="handleViewMallUrl(row, 3)" class="a-line">{{
                  row.purchaseName
                }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="type"
              :label="$t('page.content.category')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }"
                ><span>{{ row.type }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="purchaseTypeName"
              :label="$t('page.content.purchaseType')"
              width="150"
            >
              <!-- <template slot-scope="{ row }"
                ><span :title="row.purchaseType">{{
                  row.purchaseTypeName == "2"
                    ? row.purchaseClassName
                      ? row.purchaseClassName
                      : row.purchaseTypeName == "1"
                      ? $t("page.content.inquiry")
                      : row.purchaseTypeName == "2"
                      ? $t("page.content.otherProcurement")
                      : row.purchaseTypeName == "5"
                      ? $t("page.content.inviteBidd")
                      : row.purchaseTypeName == "7"
                      ? $t("page.content.labelMenu10")
                      : row.purchaseTypeName == "8"
                      ? $t("page.content.labelMenu11")
                      : row.purchaseTypeName == "24"
                      ? $t("page.content.openCompetitiveNegotiation")
                      : row.purchaseTypeName == "4"
                      ? $t("page.content.competitiveNegotiation")
                      : row.purchaseTypeName == "50"
                      ? $t("page.content.agreementType")
                      : row.purchaseTypeName == "53"
                      ? $t("page.content.invitationType")
                      : row.purchaseTypeName == "0"
                      ? $t("page.content.publicBidding")
                      : row.purchaseTypeName == "3"
                      ? $t("page.content.invitationTender")
                      : ""
                    : row.purchaseTypeName == "1"
                    ? $t("page.content.inquiry")
                    : row.purchaseTypeName == "2"
                    ? $t("page.content.otherProcurement")
                    : row.purchaseTypeName == "5"
                    ? $t("page.content.inviteBidd")
                    : row.purchaseTypeName == "7"
                    ? $t("page.content.labelMenu10")
                    : row.purchaseTypeName == "8"
                    ? $t("page.content.labelMenu11")
                    : row.purchaseTypeName == "24"
                    ? $t("page.content.openCompetitiveNegotiation")
                    : row.purchaseTypeName == "4"
                    ? $t("page.content.competitiveNegotiation")
                    : row.purchaseTypeName == "50"
                    ? $t("page.content.agreementType")
                    : row.purchaseTypeName == "53"
                    ? $t("page.content.invitationType")
                    : row.purchaseTypeName == "0"
                    ? $t("page.content.publicBidding")
                    : row.purchaseTypeName == "3"
                    ? $t("page.content.invitationTender")
                    : ""
                }}</span></template
              > -->
            </el-table-column>
            <el-table-column
              prop="sourceSystem"
              :label="$t('page.content.yewuSource')"
            >
            </el-table-column>
            <el-table-column
              prop="publishedTime"
              :label="$t('page.content.publishTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.publishedTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="purchaseEndTime"
              :label="$t('page.content.ApplicationTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.purchaseEndTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!--采购公告-->
      <!--<template>-->
      <!--<div class="notice-class">-->
      <!--<div class="wrapper">-->
      <!--<el-tabs-->
      <!--class="el-tabs__customize"-->
      <!--v-model="tabName"-->
      <!--@tab-click="handleClick"-->
      <!--&gt;-->
      <!--&lt;!&ndash;公开&ndash;&gt;-->
      <!--<el-tab-pane :label="$t('page.content.open')" name="98">-->
      <!--&lt;!&ndash; <template v-for="(item1, index1) in noticeData"> &ndash;&gt;-->
      <!--<div class="notice-class" :key="index1">-->
      <!--<div class="notice-detail-list mt15 ccui-clearfix">-->
      <!--<template v-for="(item, index) in noticeData">-->
      <!--<div-->
      <!--:class="-->
      <!--`notice-detail-box mb20 fl ${(index + 1) % 5 !== 0 &&-->
      <!--'mr20'}`-->
      <!--"-->
      <!--:key="index"-->
      <!--&gt;-->
      <!--<div-->
      <!--class="notice-detail-box-out"-->
      <!--v-if="item.isEmpty !== 1"-->
      <!--@click="handleView(item)"-->
      <!--&gt;-->
      <!--<notice-item-block :data="item"></notice-item-block>-->
      <!--</div>-->
      <!--<div class="empty-content" v-else>-->
      <!--{{ $t("page.content.blockNoData") }}-->
      <!--</div>-->
      <!--<notice-item-bottom-btn-->
      <!--:item="item"-->
      <!--&gt;</notice-item-bottom-btn>-->
      <!--</div>-->
      <!--</template>-->
      <!--</div>-->
      <!--</div>-->
      <!--&lt;!&ndash; </template> &ndash;&gt;-->
      <!--</el-tab-pane>-->
      <!--<el-tab-pane :label="$t('page.content.invite')" name="99">-->
      <!--&lt;!&ndash; <template v-for="(item1, index1) in noticeData"> &ndash;&gt;-->
      <!--<div class="notice-class" :key="index1">-->
      <!--<div class="notice-detail-list mt15 ccui-clearfix">-->
      <!--<template v-for="(item, index) in noticeData">-->
      <!--<div-->
      <!--:class="-->
      <!--`notice-detail-box mb20 fl ${(index + 1) % 5 !== 0 &&-->
      <!--'mr20'}`-->
      <!--"-->
      <!--:key="index"-->
      <!--&gt;-->
      <!--<div-->
      <!--class="notice-detail-box-out"-->
      <!--v-if="item.isEmpty !== 1"-->
      <!--@click="handleView(item)"-->
      <!--&gt;-->
      <!--<notice-item-block :data="item"></notice-item-block>-->
      <!--</div>-->
      <!--<div class="empty-content" v-else>-->
      <!--{{ $t("page.content.blockNoData") }}-->
      <!--</div>-->
      <!--<notice-item-bottom-btn-->
      <!--:item="item"-->
      <!--&gt;</notice-item-bottom-btn>-->
      <!--</div>-->
      <!--</template>-->
      <!--</div>-->
      <!--</div>-->
      <!--&lt;!&ndash; </template> &ndash;&gt;-->
      <!--</el-tab-pane>-->
      <!--</el-tabs>-->
      <!--<el-link-->
      <!--:underline="false"-->
      <!--type="info"-->
      <!--class="fr view-all"-->
      <!--@click="handleViewAll(tabName)"-->
      <!--&gt;{{ $t("page.content.MoreAndMore") }} ></el-link-->
      <!--&gt;-->
      <!--</div>-->
      <!--</div>-->
      <!--</template>-->
      <!-- <template v-for="(item1, index1) in noticeData">
        <div class="notice-class" :key="index1">
          <div class="wrapper">
            <div class="ccui-clearfix wrapper">
              <div class="title fl">{{ item1.noticeTitle }}<s/div>
              <el-link
                :underline="false"
                type="info"
                class="fr view-all"
                @click="handleViewAll(item1.type)"
                >{{ $t("page.content.MoreAndMore") }} ></el-link
              >
            </div>
            <div class="notice-detail-list mt15 ccui-clearfix">
              <template v-for="(item, index) in item1.rows">
                <div
                  :class="
                    `notice-detail-box mb20 fl ${(index + 1) % 5 !== 0 &&
                      'mr20'}`
                  "
                  :key="index"
                >
                  <div
                    class="notice-detail-box-out"
                    v-if="item.isEmpty !== 1"
                    @click="handleView(item)"
                  >
                    <notice-item-block :data="item"></notice-item-block>
                  </div>
                  <div class="empty-content" v-else>
                    {{ $t("page.content.blockNoData") }}
                  </div>
                  <notice-item-bottom-btn :item="item"></notice-item-bottom-btn>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template> -->

      <!--战略合作伙伴-->
      <!--      <div-->
      <!--        :class="-->
      <!--          `notice-class ${-->
      <!--            noticeData % 2 === 0 ? 'notice-class-1' : 'notice-class-2'-->
      <!--          }`-->
      <!--        "-->
      <!--      >-->
      <!--        <div class="wrapper">-->
      <!--          <div class="title">战略合作伙伴</div>-->
      <!--          <div class="notice-detail-list mt15 ccui-clearfix">-->
      <!--            <template v-for="(item, index) in cardList">-->
      <!--              <div-->
      <!--                :key="index"-->
      <!--                :class="`box-card fl mb20 ${(index + 1) % 5 !== 0 && 'mr20'}`"-->
      <!--              >-->
      <!--                <img class="card-img" src="" />-->
      <!--              </div>-->
      <!--            </template>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import {
  listSupBidNotice,
  listSupOpenAndInvitationNotice,
  qryJointProNotice,
  qryJointProNoticeByMarket,
  OAuth
} from "@/app/shop/api/shopping";
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
// import noticeItemBlock from "@/app/shop/components/noticeItemBlock";
import moment from "moment";
// import noticeItemBottomBtn from "@/app/shop/components/noticeItemBottomBtn";
import { getArgs } from "@/basa/utils";
import Cookies from "js-cookie";
export default {
  name: "noticeItem",
  mixins: [mixinHomePage],
  components: {
    // noticeItemBlock,
    // noticeItemBottomBtn
  },
  data() {
    return {
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL),
      pageTotal: 1,
      pageSize: 10,
      pageNo: 1,
      moment,
      noticeData: [],
      wasteData: [],
      lianheData: [],
      overseasData: [], // 海外采购专区公告
      mallPurchaseData: [],
      cardList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      supInfo: this.$store.state.user.supInfo || {},
      noticeType: 98,
      isShowInvi: false,
      tabName: "98",
      tipLoading: false,
      wasteType: 12,
      wasteName: 12,
      nodeList7: [],
      nodeList8: []
    };
  },
  mounted() {},
  activated() {
    this.init();
  },
  deactivated() {
    this.noticeData = [];
    this.wasteData = [];
    this.lianheData = [];
    this.overseasData = []; // 海外采购专区公告
    this.mallPurchaseData = [];
  },
  watch: {
    tabName(val) {
      switch (val) {
        case "98": // 公开
          this.pageNo = 1;
          this.noticeType = 98;
          this.getNoticeList({
            noticeType: 98
          });
          break;
        case "99": //邀请
          this.pageNo = 1;
          this.noticeType = 99;
          this.getNoticeList({
            noticeType: 99
          });
          break;
        case "8": //流标公告
          this.noticeType = 8;
          // this.getMessageList({
          //   noticeType: 8
          // });
          this.getNoticeList({
            noticeType: 8
          });
          break;
        case "7": //补遗公告
          this.noticeType = 7;
          // this.getMessageList({
          //   noticeType: 7
          // });
          this.getNoticeList({
            // 补遗
            noticeType: 7
          });
          break;
        // case "12": //废旧物资处置
        //   this.noticeType = 12;
        //   this.getNoticeList({
        //     noticeType: 12
        //   });
        //   break;
      }
    }
  },
  methods: {
    async init() {
      this.getXunjiaList();
      // 海外采购专区公告
      this.getOverseasList();
      if (this.loginInfo.mobile) {
        if (JSON.parse(localStorage.getItem("supInfo")).supCode) {
          this.getMallPurchaseList();
        }
      }
      //1-> 公开采购  5->询价采购  6->竞争谈判 10->公开询价
      // let arr = [
      // 公开
      this.getNoticeList({
        noticeType: 98
      });
      this.getNoticeList({
        noticeType: 12
      });
      // this.getNoticeList({
      //   noticeType: 7
      // });
      // this.getNoticeList({
      //   noticeType: 8
      // });
      if (Cookies.get("access_token")) {
        this.isShowInvi = true;
        return true;
      }
    },
    oldLink() {
      if (this.baseUrl.indexOf("dev01") != -1) {
        window.location.href = "http://ec.ccccltd.cn/";
      } else if (this.baseUrl.indexOf("test01") != -1) {
        window.location.href = "http://ec.ccccltd.cn/";
      } else if (this.baseUrl.indexOf("uat01") != -1) {
        window.location.href = "http://ec.ccccltd.cn/";
      } else {
        window.location.href = "http://ec.ccccltd.cn/";
      }
    },
    isLogin() {
      if (Cookies.get("access_token")) {
        return true;
      } else {
        this.$message({
          message: this.$t("page.content.loginTip"),
          type: "warning",
          offset: document.documentElement.clientHeight / 2 - 21
        });
        return false;
      }
    },
    handleViewMallUrl(row) {
      window.open(row.noticeUrl, "_blank");
    },
    handleViewLianhe(row, type) {
      if (Cookies.get("access_token")) {
        this.lianheGo(row, type);
      } else {
        this.$message({
          showClose: true,
          message: "请先登录！",
          duration: 3000,
          type: "error",
          ccuiCustom: true
        });
      }
    },
    lianheGo(row, type) {
      //type详情1 更多2
      let oma_remote_url =
          "https://liancai.iccec.cn/account/supplier@corpid@10000",
        redirect =
          "https://liancai.iccec.cn/mall/inquiryDetail?planNo=" +
          row.noticeCode;
      if (type == 2) {
        redirect = "https://liancai.iccec.cn/mall/purchase?";
      }
      let code = "";
      if (window.location.host.indexOf("test01") != -1) {
        oma_remote_url = "http://lczq.bmmyou.com/account/supplier@corpid@10000";
        redirect =
          "http://lczq.bmmyou.com/mall/inquiryDetail?planNo=" + row.noticeCode;
        if (type == 2) {
          redirect = "http://lczq.bmmyou.com?";
        }
      }
      OAuth({
        isShowLoading: true,
        // oma_remote_url: "https://aimarket.iccec.cn/front/login@corpid@10000"
        oma_remote_url: oma_remote_url,
        liancai: true
      })
        .then(res => {
          if (res.data.code == 111) {
            this.$message({
              showClose: true,
              message: "请先登录！",
              duration: 3000,
              type: "error",
              ccuiCustom: true
            });
            return;
          }
          let query = res.data.data.split("?")[1];
          let pairs = query.split("&");
          for (var i = 0; i < pairs.length; i++) {
            var pos = pairs[i].indexOf("=");
            if (pos == -1) continue;
            var argname = pairs[i].substring(0, pos),
              value = pairs[i].substring(pos + 1);
            value = decodeURIComponent(value);

            if ("code" == argname) {
              code = value;
            }
          }
          console.log(
            res.data.data.split("?")[0] +
              "?supinfoId=" +
              sessionStorage.getItem("supCodeUrl") +
              "&redirect=" +
              encodeURIComponent(redirect) +
              "&code=" +
              code
          );
          window.open(
            res.data.data.split("?")[0] +
              "?supinfoId=" +
              sessionStorage.getItem("supCodeUrl") +
              "&redirect=" +
              encodeURIComponent(redirect) +
              "&code=" +
              code,
            "_blank"
          );
        })
        .catch(res => {
          if (res.data.code == 111) {
            this.$message({
              showClose: true,
              message: "请先登录！",
              duration: 3000,
              type: "error",
              ccuiCustom: true
            });
          }
        });
    },
    // 海外采购专区公告 start
    handleViewOverseas(row, type) {
      if (Cookies.get("access_token")) {
        this.overseasGo(row, type);
      } else {
        this.$message({
          showClose: true,
          message: "请先登录！",
          duration: 3000,
          type: "error",
          ccuiCustom: true
        });
      }
    },
    overseasGo(row, type) {
      //type详情1 更多2
      let oma_remote_url = "https://hwsp.iccec.cn/@corpid@10000",
        redirect = "https://hwsp.iccec.cn/";
      let code = "";
      if (
        window.location.host.indexOf("test01") != -1 ||
        window.location.host.indexOf("uat01") != -1
      ) {
        oma_remote_url = "https://uat01-hwsp.iccec.cn/@corpid@10000";
        redirect = "https://uat01-hwsp.iccec.cn/";
      }
      OAuth({
        isShowLoading: true,
        // oma_remote_url: "https://aimarket.iccec.cn/front/login@corpid@10000"
        oma_remote_url: oma_remote_url,
        liancai: true
      })
        .then(res => {
          if (res.data.code == 111) {
            this.$message({
              showClose: true,
              message: "请先登录！",
              duration: 3000,
              type: "error",
              ccuiCustom: true
            });
            return;
          }
          let query = res.data.data.split("?")[1];
          let pairs = query.split("&");
          for (var i = 0; i < pairs.length; i++) {
            var pos = pairs[i].indexOf("=");
            if (pos == -1) continue;
            var argname = pairs[i].substring(0, pos),
              value = pairs[i].substring(pos + 1);
            value = decodeURIComponent(value);

            if ("code" == argname) {
              code = value;
            }
          }
          console.log(
            res.data.data.split("?")[0] +
              "?supinfoId=" +
              sessionStorage.getItem("supCodeUrl") +
              "&redirect=" +
              encodeURIComponent(redirect) +
              "&code=" +
              code
          );
          window.open(
            res.data.data.split("?")[0] +
              "?supinfoId=" +
              sessionStorage.getItem("supCodeUrl") +
              "&redirect=" +
              encodeURIComponent(redirect) +
              "&code=" +
              code,
            "_blank"
          );
        })
        .catch(res => {
          if (res.data.code == 111) {
            this.$message({
              showClose: true,
              message: "请先登录！",
              duration: 3000,
              type: "error",
              ccuiCustom: true
            });
          }
        });
    },
    // 海外采购专区公告 end
    handleViewDetail(row) {
      let url = this.$router.resolve({
        path: "/viewNoticeSimpleDetail",
        query: {
          type: this.tabName,
          schemeId: row.schemeId,
          schemeName: row.schemeName,
          schemeCode: row.schemeCode,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          supCode: getArgs("SUPCODE")
            ? getArgs("SUPCODE")
            : sessionStorage.supCode && sessionStorage.supCode != "undefined"
            ? sessionStorage.supCode
            : "",
          supName: row.supName
        }
      });
      window.open(url.href, "_blank");
    },
    getNoticeList(obj) {
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      // return new Promise(resolve => {
      let params = {
        noticeStatusEndFlag: "1",
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        supCodeList: supCodeList,
        noticeType: this.noticeType,
        isShowPageLoading: true
      };
      if (
        Cookies.get("language") !== undefined &&
        Cookies.get("language") !== "zh-cn"
      ) {
        params.overseasSupFlag = 1;
      }
      Object.assign(params, obj);
      if (params.noticeType == 98) {
        this.tipLoading = true;
      }
      let getList =
        params.noticeType == "98" || params.noticeType == "99"
          ? listSupOpenAndInvitationNotice
          : listSupBidNotice;
      getList(params)
        .then(res => {
          if (params.noticeType == 98) {
            this.tipLoading = false;
          }
          // this.tipLoading = false;
          console.log(params, res.data.data.rows, "wasteData");
          if (res.data.code === "0") {
            this.pageTotal = res.data.data.recordsTotal;
            if (params.noticeType == 12) {
              this.wasteData = res.data.data.rows;
            } else {
              this.noticeData = res.data.data.rows;
              this.noticeData.forEach(row => {
                row.purchaseName =
                  row.purchaseType == "2"
                    ? row.purchaseClassName
                      ? row.purchaseClassName
                      : row.purchaseType == "1"
                      ? this.$t("page.content.inquiry")
                      : row.purchaseType == "2"
                      ? this.$t("page.content.otherProcurement")
                      : row.purchaseType == "5"
                      ? this.$t("page.content.inviteBidd")
                      : row.purchaseType == "7"
                      ? this.$t("page.content.labelMenu10")
                      : row.purchaseType == "8"
                      ? this.$t("page.content.labelMenu11")
                      : row.purchaseType == "24"
                      ? this.$t("page.content.openCompetitiveNegotiation")
                      : row.purchaseType == "4"
                      ? this.$t("page.content.competitiveNegotiation")
                      : row.purchaseType == "50"
                      ? this.$t("page.content.agreementType")
                      : row.purchaseType == "53"
                      ? this.$t("page.content.invitationType")
                      : row.purchaseType == "0"
                      ? this.$t("page.content.publicBidding")
                      : row.purchaseType == "3"
                      ? this.$t("page.content.invitationTender")
                      : ""
                    : row.purchaseType == "1"
                    ? this.$t("page.content.inquiry")
                    : row.purchaseType == "2"
                    ? this.$t("page.content.otherProcurement")
                    : row.purchaseType == "5"
                    ? this.$t("page.content.inviteBidd")
                    : row.purchaseType == "7"
                    ? this.$t("page.content.labelMenu10")
                    : row.purchaseType == "8"
                    ? this.$t("page.content.labelMenu11")
                    : row.purchaseType == "24"
                    ? this.$t("page.content.openCompetitiveNegotiation")
                    : row.purchaseType == "4"
                    ? this.$t("page.content.competitiveNegotiation")
                    : row.purchaseType == "50"
                    ? this.$t("page.content.agreementType")
                    : row.purchaseType == "53"
                    ? this.$t("page.content.invitationType")
                    : row.purchaseType == "0"
                    ? this.$t("page.content.publicBidding")
                    : row.purchaseType == "3"
                    ? this.$t("page.content.invitationTender")
                    : "";
              });
            }
            console.log(this.noticeData, "noticeData");
          }
        })
        .catch(() => {
          if (params.noticeType == 98) {
            this.tipLoading = false;
          }
          // this.tipLoading = false;
        });
      // });
    },
    getXunjiaList(obj) {
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      // return new Promise(resolve => {
      let params = {
        noticeStatusEndFlag: "1",
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        supCodeList: supCodeList,
        noticeType: this.noticeType,
        isShowPageLoading: true
      };
      if (
        Cookies.get("language") !== undefined &&
        Cookies.get("language") !== "zh-cn"
      ) {
        params.overseasSupFlag = 1;
      }
      Object.assign(params, obj);
      qryJointProNotice(params).then(res => {
        if (res.data.code === "0") {
          this.pageTotal = res.data.data.recordsTotal;
          this.lianheData = res.data.data;
        }
      });
    },
    getOverseasList(obj) {
      // let supCodeList = [];
      // if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
      //   supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
      //     return item.supCode;
      //   });
      // }
      // return new Promise(resolve => {
      let params = {
        data: {
          sourceSystemCode: "3"
        },
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        // supCodeList: supCodeList,
        // noticeType: this.noticeType,
        isShowPageLoading: true
      };
      // if (
      //   Cookies.get("language") !== undefined &&
      //   Cookies.get("language") !== "zh-cn"
      // ) {
      //   params.overseasSupFlag = 1;
      // }
      Object.assign(params, obj);
      qryJointProNotice(params).then(res => {
        if (res.data.code === "0") {
          this.pageTotal = res.data.data.recordsTotal;
          this.overseasData = res.data.data;
        }
      });
    },
    getMallPurchaseList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        supCode: JSON.parse(localStorage.getItem("supInfo")).supCode,
        // supCode: "2001200100000089225",
        title: "",
        isShowPageLoading: true
      };
      qryJointProNoticeByMarket(params).then(res => {
        if (res.data.code === "0") {
          this.pageTotal = res.data.data.recordsTotal;
          this.mallPurchaseData = res.data.data.rows;
        }
      });
    },
    getMessageList(obj) {
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      let params = {
        noticeStatusEndFlag: 1,
        pageNo: 1,
        pageSize: 10,
        supCodeList: supCodeList
      };
      if (
        Cookies.get("language") !== undefined &&
        Cookies.get("language") !== "zh-cn"
      ) {
        params.overseasSupFlag = 1;
      }
      Object.assign(params, obj);
      listSupBidNotice(params).then(res => {
        if (res.data.code === "0") {
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.$set(this, "nodeList" + params.noticeType, res.data.data.rows);
          }
        }
      });
    },
    unique(arr) {
      // 根据唯一标识orderId来对数组进行过滤
      const res = new Map(); //定义常量 res,值为一个Map对象实例 //返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
      return arr.filter(
        arr => !res.has(arr.schemeId) && res.set(arr.schemeId, 1)
      );
    },
    handleViewAll(type) {
      if (type == 7 || type == 8 || type == 9) {
        let url = this.$router.resolve({
          path: "/announcementsList",
          query: {
            type: type,
            source: "1"
          }
        });
        window.open(url.href, "_blank");
        // let params = ["type=" + type, "source=1"];
        // let url = "/announcementsList?" + params.join("&");
        // window.open(window.location.origin + url, "_blank");
      } else {
        let url = this.$router.resolve({
          path: "/searchList",
          query: {
            type: type
          }
        });
        window.open(url.href, "_blank");

        // let params = ["type=" + type];
        // let url = "/searchList?" + params.join("&");
        // window.open(window.location.origin + url, "_blank");
      }
    },
    handleClick(data) {
      this.tabName = data.name;
    },
    handlePrev() {
      --this.pageNo;
      let obj = {
        pageNo: this.props_pageNo,
        pageSize: this.pageSize
      };
      this.getNoticeList(obj);
    },
    handleNext() {
      ++this.pageNo;
      let obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      this.getNoticeList(obj);
    },
    handleSizeChange(val) {
      this.props_pageNo = 1;
      if (val !== "none") {
        this.pageSize = val;
        // setSessionItem("pageSize", this.tableName, val);
      }
      this.$nextTick(() => {
        let doms = document.getElementsByClassName("el-input__inner");
        for (let domChild of doms) {
          domChild.blur();
        }
      });
      let obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      this.getNoticeList(obj);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      let obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      this.getNoticeList(obj);
    }
  },
  computed: {
    showNoticeTitle() {
      return item => {
        //       return item => {https://docs.qq.com/sheet/DQkdUaFNHenVIc0VY?tab=jw2dyn 68行
        // if (item.supName) {
        //   return `[${item.supName}]${item.noticeTitle}`;
        // } else {
        //   return item.noticeTitle;
        // }
        return item.noticeTitle;
      };
    },
    languagezh_cn() {
      return (Cookies.get("language") || "zh-cn") === "zh-cn";
    },
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    }
  }
};
</script>

<style scoped lang="scss">
.old-version {
  margin-left: 30px;
  width: 722px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.old-version:hover {
  color: #0089ef;
  cursor: pointer;
  text-decoration: underline;
}
// .old-note {
//   display: inline-block;
//   width: 722px;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
// }
// .old-note:hover {
//   color: #0089ef;
//   cursor: pointer;
//   text-decoration: underline;
// }
/deep/.table_header {
  background: #edf4f9;
}
/deep/.el-table__header {
  background: #edf4f9;
  padding: 0 10px;
}
.notice-list .notice-list-group {
  padding-top: 0;
}
/deep/.el-table {
  margin-top: 0 !important;
}
/deep/.el-table__body-wrapper {
  padding: 10px;
  padding-bottom: 35px;
}
.notice-list {
  margin-bottom: 0 !important;
}
/deep/.el-table__body {
  tr {
    .cell {
      height: 30px;
      line-height: 30px;
    }
  }
}
.a-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.a-line:hover {
  color: #0089ef;
  text-decoration: underline;
}
/deep/.pt10 {
}
.wrapper {
  margin-bottom: 20px;
}
.ccui-table-footer {
  height: 47px;
  padding-top: 15px;
  padding-right: 10px;
  background: #fff;
}
.notice-list-group {
  padding-top: 8px;
  padding: 10px;
  background: #fff;
  .a-line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .a-line:hover {
    color: #0089ef;
    text-decoration: underline;
  }
  a {
    padding-top: 12px;
    display: block;
    cursor: pointer;
    font-size: 13px;
    line-height: 18px;
    color: #4a4a4a;
    font-weight: 500;
    float: left;
    text-align: right;
    text-decoration: none;
    span {
      color: #999999;
      width: 79px;
      float: left;
      &:hover {
        color: #0089ef;
        text-decoration: underline;
      }
    }
    .ellipsis {
      float: left;
      display: block;
      width: 466px;
      text-align: left;
      color: #4a4a4a;
    }
    &:nth-child(2n) {
      margin-left: 40px;
    }
  }
}
</style>
